import { render } from "./MusicIndex.vue?vue&type=template&id=ef1883f2&scoped=true"
import script from "./MusicIndex.vue?vue&type=script&lang=ts"
export * from "./MusicIndex.vue?vue&type=script&lang=ts"

import "./MusicIndex.vue?vue&type=style&index=0&id=ef1883f2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ef1883f2"

export default script